module.exports = __webpack_public_path__ + "img/enging_room_pic04.812e5875.png";